const users = (state) => state.users;

export default users;
